'use client';

import { DEFAULT_REFRESH_THRESHOLD, usePullToRefresh } from '@/hooks/usePullToRefresh';
import { cn } from '@/lib/utils';
import { Loader2, RotateCw } from 'lucide-react';

export default function PullToRefresh() {
	const { isRefreshing, pullPosition } = usePullToRefresh({
		onRefresh: () => {
			location.reload();
		},
		isDisabled: false
	});

	return (
		<div
			style={{
				top: (isRefreshing ? DEFAULT_REFRESH_THRESHOLD : pullPosition) - DEFAULT_REFRESH_THRESHOLD / 2,
				opacity: isRefreshing || pullPosition > 0 ? 1 : 0
			}}
			className='fixed z-[1000] rounded-full p-2 flex items-center justify-center w-full'
		>
			<div>
				{!isRefreshing && (
					<RotateCw
						className={cn('size-10 text-app-primary-color-dim')}
						style={!isRefreshing ? { transform: `rotate(${pullPosition}deg)` } : {}}
					/>
				)}

				{isRefreshing && (
					<Loader2
						className={cn('size-10 text-app-primary-color-dim', isRefreshing && 'animate-spin')}
						style={!isRefreshing ? { transform: `rotate(${pullPosition}deg)` } : {}}
					/>
				)}
			</div>
		</div>
	);
}
